import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Envasado/editEnvasado`, method: 'POST', body: values, token: token})
}
